module.exports = __webpack_public_path__ + "static/media/dthq_logo.b53db7fb.png";